import { BASE_URL } from "config";
import * as base from "./_base";

export const endpoints = {
    list: `${BASE_URL}/api/v1/job/`,
    detail: (id) => `${BASE_URL}/api/v1/job/${id}/`,
};

export const jobListLoad = (token, payload) => base.ListLoad(endpoints.list, token, payload);
export const jobDetailLoad = (token, { id }) => base.DetailLoad(endpoints.detail, token, { id });
export const jobUpdate = (token, data) => base.Update(endpoints.list, endpoints.detail, token, data);
export const jobDelete = (token, data) => base.Delete(endpoints.detail, token, data);
